/**
 * Локальные (fallback) стикерпаки для использования когда API недоступен.
 * SVG-файлы лежат в public/stickers/ и доступны как статика.
 *
 * Структура совместима с серверным StickerPackResponse:
 * { id, name, iconFileId?, sortOrder, isActive, stickers[] }
 * StickerResponse: { id, imageFileId, emoji?, sortOrder, isActive }
 *
 * imageFileId здесь — путь к SVG-файлу. StickerItem/StickerImage
 * определяют локальные пути (начинаются с '/') и используют прямой <img>
 * вместо filesApi.downloadImage.
 *
 * Поле icon хранится как эмодзи-строка (не UUID файла) — StickerPicker
 * использует pack.icon для отображения таба пака.
 */

export const LOCAL_STICKER_PACKS = [
    {
        id: 'local-emotions',
        name: 'Эмоции',
        icon: '😀',
        iconFileId: null,
        sortOrder: 0,
        isActive: true,
        stickers: [
            { id: 'emo-happy',    imageFileId: '/stickers/emotions/happy.svg',    emoji: '😀', sortOrder: 0, isActive: true },
            { id: 'emo-sad',      imageFileId: '/stickers/emotions/sad.svg',      emoji: '😢', sortOrder: 1, isActive: true },
            { id: 'emo-angry',    imageFileId: '/stickers/emotions/angry.svg',    emoji: '😠', sortOrder: 2, isActive: true },
            { id: 'emo-laugh',    imageFileId: '/stickers/emotions/laugh.svg',    emoji: '😆', sortOrder: 3, isActive: true },
            { id: 'emo-love',     imageFileId: '/stickers/emotions/love.svg',     emoji: '😍', sortOrder: 4, isActive: true },
            { id: 'emo-neutral',  imageFileId: '/stickers/emotions/neutral.svg',  emoji: '😐', sortOrder: 5, isActive: true },
            { id: 'emo-cool',     imageFileId: '/stickers/emotions/cool.svg',     emoji: '😎', sortOrder: 6, isActive: true },
            { id: 'emo-cry',      imageFileId: '/stickers/emotions/cry.svg',      emoji: '😭', sortOrder: 7, isActive: true },
        ],
    },
    {
        id: 'local-gestures',
        name: 'Жесты',
        icon: '👍',
        iconFileId: null,
        sortOrder: 1,
        isActive: true,
        stickers: [
            { id: 'ges-thumbs-up',   imageFileId: '/stickers/gestures/thumbs-up.svg',   emoji: '👍', sortOrder: 0, isActive: true },
            { id: 'ges-thumbs-down', imageFileId: '/stickers/gestures/thumbs-down.svg', emoji: '👎', sortOrder: 1, isActive: true },
            { id: 'ges-ok',          imageFileId: '/stickers/gestures/ok.svg',          emoji: '👌', sortOrder: 2, isActive: true },
            { id: 'ges-peace',       imageFileId: '/stickers/gestures/peace.svg',       emoji: '✌️', sortOrder: 3, isActive: true },
            { id: 'ges-fist',        imageFileId: '/stickers/gestures/fist.svg',        emoji: '✊', sortOrder: 4, isActive: true },
            { id: 'ges-wave',        imageFileId: '/stickers/gestures/wave.svg',        emoji: '👋', sortOrder: 5, isActive: true },
            { id: 'ges-clap',        imageFileId: '/stickers/gestures/clap.svg',        emoji: '👏', sortOrder: 6, isActive: true },
            { id: 'ges-point',       imageFileId: '/stickers/gestures/point.svg',       emoji: '👆', sortOrder: 7, isActive: true },
        ],
    },
    {
        id: 'local-hearts',
        name: 'Сердца',
        icon: '❤️',
        iconFileId: null,
        sortOrder: 2,
        isActive: true,
        stickers: [
            { id: 'hrt-red',      imageFileId: '/stickers/hearts/red-heart.svg',      emoji: '❤️', sortOrder: 0, isActive: true },
            { id: 'hrt-sparkle',  imageFileId: '/stickers/hearts/sparkle-heart.svg',  emoji: '✨', sortOrder: 1, isActive: true },
            { id: 'hrt-blue',     imageFileId: '/stickers/hearts/blue-heart.svg',     emoji: '💙', sortOrder: 2, isActive: true },
            { id: 'hrt-green',    imageFileId: '/stickers/hearts/green-heart.svg',    emoji: '💚', sortOrder: 3, isActive: true },
            { id: 'hrt-rainbow',  imageFileId: '/stickers/hearts/rainbow-heart.svg',  emoji: '🌈', sortOrder: 4, isActive: true },
            { id: 'hrt-broken',   imageFileId: '/stickers/hearts/broken-heart.svg',   emoji: '💔', sortOrder: 5, isActive: true },
            { id: 'hrt-fire',     imageFileId: '/stickers/hearts/fire-heart.svg',     emoji: '🔥', sortOrder: 6, isActive: true },
            { id: 'hrt-galaxy',   imageFileId: '/stickers/hearts/galaxy-heart.svg',   emoji: '🌌', sortOrder: 7, isActive: true },
        ],
    },
];
